// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__1a__e","imageUploader":"EGiftCard_imageUploader__EcVpc"};